import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AlarmOn from "../../assets/icons/Header/notification_on.svg";
import AlarmOff from "../../assets/icons/Header/notification_off.svg";

const AdsAlarm = ({ data, currentTab }) => {
    const [open, setOpen] = useState(false);
    const [notices, setNotices] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [unreadNoticeNos, setUnreadNoticeNos] = useState([]);
    const navigate = useNavigate();

    const storeBusinessNumber = data.store_business_number;
    const fromTab = currentTab === "mypage" ? "mypage" : "home";

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userId = localStorage.getItem("user_id");
                const [noticeRes, readRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice`),
                    axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice/check/read`, {
                        params: { user_id: userId },
                    }),
                ]);

                const list = noticeRes.data || [];
                setNotices(list);

                // 노출 가능한 공지(id 집합)
                const visibleIds = new Set(
                    list
                        .filter((n) => n.notice_post === "Y")
                        .map((n) => Number(n.notice_no))
                );

                const unreadList = readRes.data?.unread_notices ?? [];

                // 30일 기준
                const now = new Date();
                const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
                const thirtyDaysAgo = new Date(now.getTime() - THIRTY_DAYS_MS);

                // 1) 노출 가능한 공지 중에서
                // 2) 이벤트는 최근 30일, 일반은 전부 포함
                const filteredUnread = unreadList.filter((n) => {
                    const id = Number(n.notice_no);
                    if (!visibleIds.has(id)) return false;

                    const type = n.notice_type;
                    const createdAt = new Date(n.created_at);

                    if (type === "이벤트") {
                        return createdAt >= thirtyDaysAgo;
                    }
                    if (type === "일반") {
                        return true;
                    }
                    // 그 외 타입은 카운트 안 함 (원하면 true로 바꿔도 됨)
                    return false;
                });

                const unreadIds = filteredUnread.map((n) => Number(n.notice_no));

                setUnreadNoticeNos(unreadIds);
                setUnreadCount(filteredUnread.length);
            } catch (error) {
                console.error("데이터 불러오기 실패:", error);
            }
        };

        fetchData();
    }, []);

    const handleNoticeClick = async (notice) => {

        const userId = localStorage.getItem("user_id");

        if (notice.notice_post !== "Y") {
            navigate(`/ads/notice/${notice.notice_no}`, {
                state: { notice, storeBusinessNumber, fromTab },
            });
            return;
        }

        setUnreadNoticeNos((prev) => {
            const next = prev.filter((id) => id !== Number(notice.notice_no));
            setUnreadCount(next.length);
            return next;
        });

        try {
            await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/notice/read`, {
                user_id: userId,
                notice_no: notice.notice_no,
            });
        } catch (error) {
            console.error("읽음 처리 실패:", error);
        }

        navigate(`/ads/notice/${notice.notice_no}`, {
            state: { notice, storeBusinessNumber, fromTab },
        });
    };

    return (
        <div className="flex items-center z-10">
            <button
                onClick={() => navigate("/ads/alarm", { state: { storeBusinessNumber, fromTab } })}
                aria-label={unreadCount > 0 ? "읽지 않은 알림 있음" : "알림"}
                className="relative"
            >
                <img
                    src={unreadCount > 0 ? AlarmOn : AlarmOff}
                    alt="알림 아이콘"
                    className=""
                    draggable={false}
                />
            </button>

            {open && (
                <div className="relative z-[1000]" onClick={(e) => e.stopPropagation()}>
                    <div className="absolute -right-2 top-3 w-64 max-h-40 bg-white border border-gray-200 rounded-md shadow-lg z-[50] overflow-y-auto">
                        {notices.length > 0 ? (
                            notices.map((notice) => {
                                const isUnread = unreadNoticeNos.includes(notice.notice_no);
                                return (
                                    <div
                                        key={notice.notice_no}
                                        className="p-4 border-b border-gray-100 cursor-pointer"
                                        onClick={() => handleNoticeClick(notice)}
                                    >
                                        <p
                                            className={`pl-1 relative text-sm font-semibold min-w-0 ${isUnread ? "text-gray-900" : "text-gray-500"
                                                }`}
                                        >
                                            <span className="block truncate">{notice.notice_title}</span>
                                        </p>
                                        <p
                                            className={`pl-1 text-sm line-clamp-1 ${isUnread ? "text-gray-600" : "text-gray-400"
                                                }`}
                                        >
                                            {notice.notice_content}
                                        </p>
                                        <p>
                                            {fromTab}
                                        </p>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="p-4 text-center text-gray-500">공지사항이 없습니다.</div>
                        )}
                    </div>
                    <div className="absolute top-1 right-1 w-4 h-4 bg-white rotate-45 border-l border-t border-gray-200 z-[60]" />
                </div>
            )}

            {open && <div className="fixed inset-0 z-[999] bg-transparent" onClick={() => setOpen(false)} />}
        </div>
    );
};

export default AdsAlarm;
